import { COMPANY_NOT_FOUND_FIELD } from '../constants';

const handleFormatCompaniesData = data => {
  const results = data.data.source
    .map(item => {
      const { uid, uri, ...data } = item;
      return {
        value: data.currentName + uri,
        uri,
        uid,
        label: data.currentName,
        company: data,
      };
    })
    .filter(item => item.uri !== null);
  return [...results, COMPANY_NOT_FOUND_FIELD];
};

export default handleFormatCompaniesData;
